import { Component, OnInit } from '@angular/core';
import { DirectusService } from '../../../../vendors/directus/directus.service';
import { UtilityService } from '@modules/utility/services';

@Component({
  selector: 'app-subnavigation',
  templateUrl: './subnavigation.component.html',
  styleUrls: ['./subnavigation.component.scss']
})
export class SubnavigationComponent implements OnInit {
  subnavItems;

  constructor(
    private directus: DirectusService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.subnavItems = this.directus.getSubnav();
  }

  externalLinkClicked(link: string) {
    this.utilityService.handleDynamicLink(link);
  }

  smoothScroll(elementId: string) {
    const element = document.querySelector(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  setCurrent(event) {
    const els = document.querySelectorAll('.subnavItem');
    for (let i = 0; i < els.length; i++) {
      els[i].classList.remove('current');
    }
    event.currentTarget.classList.add('current');
  }

  clearUnderline(event) {
    event.currentTarget.classList.remove('current');
  }
}
